import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { cn } from '../../../util';
import { formatDateTime } from './format';

type Props = { updatedAt: number; onRetry: () => void; className?: string };

/** Shown above the tiles while they carry an older answer because the refresh failed. */
export const WalletStaleNotice: FC<Props> = ({ updatedAt, onRetry, className }) => {
  const { t } = useTranslation();

  return (
    <div
      role="status"
      data-testid="wallet-stale-notice"
      className={cn(
        'flex flex-wrap items-center justify-between gap-x-4 gap-y-1 rounded bg-warning-lightest px-4 py-2 text-base text-warning-dark ring-1 ring-inset ring-warning-light forced-colors:outline forced-colors:outline-1',
        className
      )}
    >
      <span>{t('pxtraCard:staleSummary', { date: formatDateTime(updatedAt) })}</span>
      <button
        type="button"
        className="cursor-pointer border-0 bg-transparent p-0 text-base font-medium text-warning-dark underline hover:no-underline"
        onClick={onRetry}
      >
        {t('pxtraCard:retryRefresh')}
      </button>
    </div>
  );
};
